const phoneTypes = [
  {
    name: 'Direct',
    value: 'Direct',
    abbreviation: 'Direct',
  },
  {
    name: 'Fax',
    value: 'Fax',
    abbreviation: 'Fax',
  },
  {
    name: 'Home',
    value: 'Home',
    abbreviation: 'Home',
  },
  {
    name: 'Mobile',
    value: 'Mobile',
    abbreviation: 'Mobile',
  },
  {
    name: 'Office',
    value: 'Office',
    abbreviation: 'Office',
  },
  {
    name: 'Toll Free',
    value: 'Toll Free',
    abbreviation: 'Toll Free',
  },
];
export default phoneTypes;
